import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";

const CHIPS_IMG =
  "https://customer-assets-jt897jd0.emergentagent.net/job_box-hub-7/artifacts/a1351f607b6d5c92_132423%20%281%29.webp";

export default function FastFoodStrip() {
  return (
    <section className="relative py-16 sm:py-20" data-testid="fastfood-strip">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Link
            to="/fast-food"
            data-testid="fastfood-strip-link"
            className="group relative block overflow-hidden rounded-2xl border border-mint/15 clip-corner"
          >
            <img
              src={CHIPS_IMG}
              alt="Custom-printed chips box made for Planet Cafe"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-forest via-forest/80 to-forest/20" />
            <div className="relative flex flex-col justify-center gap-3 p-8 sm:p-12 min-h-[260px]">
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-mintsoft/90">
                New — Fast Food Packaging
              </p>
              <h2 className="font-display font-semibold tracking-tight text-3xl sm:text-4xl text-kraft max-w-xl leading-[1.05]">
                Running a chips joint, cafe or food truck?
              </h2>
              <p className="max-w-md text-sm text-kraft/65 leading-relaxed">
                Chips boxes, burger clamshells, pizza boxes and carriers — food-grade and
                printed with your brand.
              </p>
              <span className="mt-2 inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] uppercase text-mint">
                See the fast food line-up
                <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </span>
            </div>
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
